import { render } from "./intValue.vue?vue&type=template&id=56c54a94&ts=true"
import script from "./intValue.vue?vue&type=script&lang=ts"
export * from "./intValue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__